import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Maksutavat',
  fields: {
    hidden_payment_methods: {
      label: 'Piilotetut maksutavat',
    },
    has_online_payments: {
      label: 'Verkkomaksut käytössä',
    },
    has_paypal_upcharge: {
      label: 'Lisää 3,5 % lisämaksu PayPal-tapahtumista',
    },
    has_cash_payments: {
      label: 'Käteismaksut käytössä',
    },
    has_occ_cash_payments: {
      label: 'Call Centerin käteismaksut käytössä',
    },
    has_in_store_card_payments: {
      label: 'Myymälän korttimaksut käytössä',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Merkitse käteismaksut nimellä "Lasku"',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Kortti',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple Pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Sepa-suoraveloitus',
    [PaymentMethods.CASH]: 'Käteinen',
    [PaymentMethods.BACS_DEBIT]: 'Bacs-suoraveloitus',
    [PaymentMethods.PAY_BY_BANK]: 'Pay by bank',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Nouto',
    [ORDER_METHODS.delivery]: 'Toimitus',
    [ORDER_METHODS.room_service]: 'Huone-/pöytäpalvelu',
  },
  modals: {
    confirmation: {
      title: 'Oletko varma?',
      description:
        'Kun vahvistat, verkkomaksut ovat <strong>{{onlineState}}</strong>, käteismaksut ovat <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'pois päältä',
    on: 'käytössä',
  },
  buttons: {
    save: 'Tallenna',
    configure_online_payments: 'Määritä verkkomaksut',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
